var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-select',_vm._g(_vm._b({attrs:{"options":_vm.cities.map(function (c) { return ({label: c, value: c}); })},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var label = ref.label;
return [_c('i',{staticClass:"mdi mdi-map-marker text-primary-900"}),_vm._v(" "+_vm._s(label)+" ")]}},{key:"selected",fn:function(ref){
var label = ref.label;
return [_c('i',{staticClass:"mdi mdi-map-marker text-primary-900"}),_vm._v(" "+_vm._s(label)+" ")]}}])},'app-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }